import type React from "react";
import { toast } from "react-toastify";
import { ChatPagesContainer } from "~/components/common/chat/ChatPagesContainer";
import { VendorLayoutV2 } from "~/components/common/layouts/VendorLayoutV2";
import { SERVER_ERROR_MESSAGE } from "~/constants/AppConst";
import { useMessageSummaries } from "~/hooks/vendors/useMessageSummaries";
import { UPDATE_TEMPORARY_UNREAD_MESSAGE } from "~/models/Message";
import { isSuccess } from "~/utils/api/api_handler";
import { postTemporaryUnread } from "~/utils/api/vendors/deals/Message";

export const Page: React.FC = () => {
	const { data: messageSummaries, mutate: mutateMessageSummaries } =
		useMessageSummaries().index();
	if (messageSummaries === null) {
		return null;
	}
	const handleTemporaryUnread = async (dealId: number): Promise<void> => {
		const result = await postTemporaryUnread(dealId);
		if (isSuccess(result)) {
			await mutateMessageSummaries?.();
			toast.success(UPDATE_TEMPORARY_UNREAD_MESSAGE);
			return;
		}
		toast.error(SERVER_ERROR_MESSAGE);
	};
	return (
		<VendorLayoutV2>
			<ChatPagesContainer
				handleTemporaryUnread={handleTemporaryUnread}
				isVendor
			/>
		</VendorLayoutV2>
	);
};
